/**
 * @generated SignedSource<<cb0df13bee06f5f747dc6cda7217d723>>
 * @relayHash b3c56c101a97603233bebecea3252932
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b3c56c101a97603233bebecea3252932

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type IssueClosedStateReason = "COMPLETED" | "NOT_PLANNED" | "%future added value";
export type IssueState = "CLOSED" | "OPEN" | "%future added value";
export type UpdateIssuesBulkByQueryInput = {
  addToProjectV2Ids?: ReadonlyArray<string> | null;
  applyAssigneeIds?: ReadonlyArray<string> | null;
  applyLabelIds?: ReadonlyArray<string> | null;
  clearMilestone?: boolean | null;
  clientMutationId?: string | null;
  issueTypeId?: string | null;
  milestoneId?: string | null;
  query: string;
  removeAssigneeIds?: ReadonlyArray<string> | null;
  removeLabelIds?: ReadonlyArray<string> | null;
  repositoryId: string;
  state?: IssueState | null;
  stateReason?: IssueClosedStateReason | null;
  unsetIssueType?: boolean | null;
};
export type addIssuesToProjectsBulkByQueryMutation$variables = {
  input: UpdateIssuesBulkByQueryInput;
};
export type addIssuesToProjectsBulkByQueryMutation$data = {
  readonly updateIssuesBulkByQuery: {
    readonly jobId: string | null;
  } | null;
};
export type addIssuesToProjectsBulkByQueryMutation$rawResponse = {
  readonly updateIssuesBulkByQuery: {
    readonly jobId: string | null;
  } | null;
};
export type addIssuesToProjectsBulkByQueryMutation = {
  rawResponse: addIssuesToProjectsBulkByQueryMutation$rawResponse;
  response: addIssuesToProjectsBulkByQueryMutation$data;
  variables: addIssuesToProjectsBulkByQueryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateIssuesBulkByQueryPayload",
    "kind": "LinkedField",
    "name": "updateIssuesBulkByQuery",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jobId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "addIssuesToProjectsBulkByQueryMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "addIssuesToProjectsBulkByQueryMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "b3c56c101a97603233bebecea3252932",
    "metadata": {},
    "name": "addIssuesToProjectsBulkByQueryMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "17307308625f16ad7c5aceab5ee6f126";

export default node;
